// IronForge — Strength & Conditioning Studio
export const META = { brand: 'IronForge', tag: 'Strength · Conditioning · NYC', est: '2017' };
export const ROUTES = [
  { id: 'home', label: 'The Floor' },
  { id: 'programs', label: 'Programs' },
  { id: 'coaches', label: 'Coaches' },
  { id: 'trial', label: 'Free Trial' },
];
export const WOD = [
  { time: '06:30', t: 'Strength · Squat day', d: '5×5 Back Squat @ 80% · 3×8 RDL · 3×12 Bulgarian split', cap: '8' },
  { time: '07:30', t: 'Olympic Lift Tech', d: 'Snatch position drills · clean & jerk warm complex · 3×3 hang clean', cap: '6' },
  { time: '12:15', t: 'Conditioning · 30/30', d: '21-15-9 thruster + pull-up · 8-min EMOM 6 burpees', cap: '12' },
  { time: '17:30', t: 'Strength · Bench day', d: '5×5 Bench @ 75% · 3×10 row · 3×8 incline DB', cap: '8' },
  { time: '18:30', t: 'Open Floor', d: 'Coached open gym · max one PR attempt · log on the board', cap: '14' },
  { time: '19:30', t: 'HIIT · Tabata mix', d: '8 rounds · KB swing / DU / row · 8 rounds · plank-up / DU', cap: '16' },
];
export const PROGRAMS = [
  { code: 'P-01', t: '12-week Strength', d: '3 sessions/week · linear progression on the big four · benchmarked every 3 weeks', dur: '12 wks', price: '$420', kpi: 'Avg +18kg back squat' },
  { code: 'P-02', t: '8-week Hypertrophy', d: '4 sessions/week · 8-12 rep range · mesocycle programmed by Mira Cobalt', dur: '8 wks', price: '$320', kpi: 'Avg +6 lbs lean mass' },
  { code: 'P-03', t: '6-week Olympic', d: '3 sessions · snatch + C&J technique with Coach Ari · video review weekly', dur: '6 wks', price: '$540', kpi: 'Avg +12kg total' },
  { code: 'P-04', t: 'Open Floor', d: 'Coached open gym · monthly testing day · full PR board access', dur: 'Monthly', price: '$240/mo', kpi: 'Self-driven' },
];
export const COACHES = [
  { name: 'Coach Ari Voss', role: 'Head Coach · Olympic', cred: 'USAW L2 · 2x national qualifier · 174kg snatch · 211kg C&J', img: 'https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg?auto=compress&cs=tinysrgb&w=900' },
  { name: 'Coach Mira Cobalt', role: 'Strength Programming', cred: 'NSCA-CSCS · MSc S&C, Edinburgh · 9 yrs programming', img: 'https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg?auto=compress&cs=tinysrgb&w=900' },
  { name: 'Coach Diego Rentería', role: 'Conditioning', cred: 'CrossFit L3 · former 800m specialist · 3 Regionals appearances', img: 'https://images.pexels.com/photos/2261477/pexels-photo-2261477.jpeg?auto=compress&cs=tinysrgb&w=900' },
];
export const PRS = [
  ['M. Halloran', 'Back Squat', '218kg', '14 Feb'],
  ['L. Andersen', 'Snatch', '108kg', '13 Feb'],
  ['J. Park', 'Deadlift', '252kg', '12 Feb'],
  ['R. Voss', 'Clean & Jerk', '141kg', '12 Feb'],
  ['K. Marini', 'Strict Pull-up × 30', '30 reps', '11 Feb'],
];
